import { render } from "./ReviewsVendor.vue?vue&type=template&id=576d22e2&scoped=true"
import script from "./ReviewsVendor.vue?vue&type=script&lang=js"
export * from "./ReviewsVendor.vue?vue&type=script&lang=js"

import "./ReviewsVendor.vue?vue&type=style&index=0&id=576d22e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576d22e2"]])

export default __exports__